import { Actions } from './types/action';
import { Resource } from './types/resources';

export type Permissions = {
	action: Actions | Actions[];
	resource: Resource;
};

export const adminRole: Permissions[] = [
	{ action: ['show', 'list', 'edit-all', 'display-hidden'], resource: 'proyectos' },
	{ action: '*', resource: 'herramientas' },
	{ action: ['show', 'list', 'show-everything'], resource: 'metricas' },
	{
		action: [
			'can-public',
			'show-plantillas',
			'show-plantilla-proyectos',
			'show-plantilla-sesion',
			'delete-plantilla-admin',
			'show-fav-plantillas'
		],
		resource: 'plantillas'
	},
	{ action: '*', resource: 'curso-online' },
	{ action: '*', resource: 'configuracion' },
	{ action: '*', resource: 'configuracion-asignaturas' },
	{ action: '*', resource: 'cambio-pais-idioma' },
	{ action: '*', resource: 'red-rutas' },
	{ action: ['show'], resource: 'ruta-protegida' },
	{ action: '*', resource: 'preguntas-frecuentes' }
];

export const estudianteRole: Permissions[] = [
	{ action: ['show', 'list', 'edit-own', 'add-fav'], resource: 'proyectos' },
	{ action: ['show', 'list'], resource: 'herramientas' },
	{ action: ['show'], resource: 'curso-online' },
	{ action: ['show'], resource: 'bottomMenu' },
	{ action: ['show'], resource: 'solo-vista-respuestas-guia' },
	{ action: ['send-message', 'see-message', 'see-chat-equipo', 'show'], resource: 'chat' },
	{
		action: ['estudiante-view'],
		resource: 'preguntas-frecuentes'
	}
];

export const estudianteParcialRole: Permissions[] = [
	{ action: ['show', 'list'], resource: 'proyectos' },
	{ action: ['show', 'list'], resource: 'herramientas' },
	{ action: ['show'], resource: 'curso-online' },
	{ action: ['show'], resource: 'bottomMenu' },
	{ action: ['see-message'], resource: 'chat' },
	{
		action: ['estudiante-view'],
		resource: 'preguntas-frecuentes'
	}
];

export const profesorRole: Permissions[] = [
	{ action: ['show', 'list', 'edit-own', 'add-fav'], resource: 'proyectos' },
	{ action: ['show', 'list'], resource: 'herramientas' },
	{ action: ['show', 'list'], resource: 'metricas' },
	{
		action: ['show-plantillas', 'show-plantilla-sesion', 'show-fav-plantillas', 'own-personal-plantillas'],
		resource: 'plantillas'
	},
	{ action: ['show'], resource: 'proyectos' },
	{ action: ['show'], resource: 'herramientas' },
	{ action: ['show'], resource: 'curso-online' },
	{ action: ['send-message', 'see-message', 'see-chat-docentes', 'show'], resource: 'chat' },
	{ action: ['show'], resource: 'calendario-profesor' },
	{ action: '*', resource: 'cambio-idioma' },
	{ action: ['show', 'add-fav'], resource: 'red-rutas' },
	{ action: ['restricted-show'], resource: 'ruta-protegida' },
	{
		action: ['profesor-view'],
		resource: 'preguntas-frecuentes'
	},
	{ action: ['show'], resource: 'multiples-cuentas' }
];

export const coordinadorRole: Permissions[] = [
	{ action: ['show', 'list', 'edit-own', 'add-fav'], resource: 'proyectos' },
	{ action: ['show', 'list'], resource: 'herramientas' },
	{ action: ['show', 'list'], resource: 'metricas' },
	{
		action: ['show-plantillas', 'show-plantilla-sesion', 'show-fav-plantillas', 'own-personal-plantillas'],
		resource: 'plantillas'
	},
	{ action: ['show'], resource: 'proyectos' },
	{ action: ['show'], resource: 'herramientas' },
	{ action: ['show'], resource: 'curso-online' },
	{ action: ['send-message', 'see-message', 'see-chat-docentes', 'show'], resource: 'chat' },
	{ action: ['show'], resource: 'calendario-profesor' },
	{ action: '*', resource: 'cambio-idioma' },
	{ action: ['show', 'add-fav'], resource: 'red-rutas' },
	{ action: ['restricted-show'], resource: 'ruta-protegida' },
	{
		action: ['profesor-view'],
		resource: 'preguntas-frecuentes'
	},
	{ action: ['show'], resource: 'multiples-cuentas' }
];

export const profesorImplementadorRole: Permissions[] = [
	{ action: ['show', 'list'], resource: 'proyectos' },
	{ action: ['show', 'list'], resource: 'herramientas' },
	{ action: ['show', 'list'], resource: 'metricas' },
	{ action: ['show'], resource: 'proyectos' },
	{ action: ['show'], resource: 'herramientas' },
	{ action: ['show'], resource: 'curso-online' },
	{ action: ['show', 'add-fav'], resource: 'red-rutas' },
	{ action: ['restricted-show'], resource: 'ruta-protegida' },
	{ action: ['show'], resource: 'calendario-profesor' },
	{
		action: ['profesor-view'],
		resource: 'preguntas-frecuentes'
	},
	{ action: ['show'], resource: 'multiples-cuentas' }
];

export const monitorRole: Permissions[] = [
	{ action: ['show', 'list', 'add-fav'], resource: 'proyectos' },
	{ action: ['show', 'list'], resource: 'herramientas' },
	{ action: ['show', 'list', 'school-view'], resource: 'metricas' },
	{
		action: ['show-plantillas', 'show-plantilla-sesion', 'show-fav-plantillas', 'own-personal-plantillas'],
		resource: 'plantillas'
	},
	{ action: ['show'], resource: 'proyectos' },
	{ action: ['show'], resource: 'herramientas' },
	{ action: ['show'], resource: 'curso-online' },
	{ action: ['send-message', 'see-message', 'see-chat-only-docentes'], resource: 'chat' },
	{ action: ['school-view'], resource: 'calendario-profesor' },
	{ action: '*', resource: 'cambio-idioma' },
	{ action: ['show', 'add-fav'], resource: 'red-rutas' },
	{ action: ['restricted-show'], resource: 'ruta-protegida' },
	{
		action: ['profesor-view'],
		resource: 'preguntas-frecuentes'
	},
	{ action: ['show'], resource: 'multiples-cuentas' }
];

export const getPermissionsByRole = (role: string): Permissions[] => {
	switch (role) {
		case 'admin':
			return adminRole;
		case 'estudiante':
			return estudianteRole;
		case 'profesor':
			return profesorRole;
		case 'coordinador':
			return coordinadorRole;
		case 'profesor-implementador':
			return profesorImplementadorRole;
		case 'monitor':
			return monitorRole;
		default:
			return [];
	}
};
